// The step-by-step page guide. Step ids are the step's own stable id from
// lib/page-guides.ts, never the position — a guide that drops a step the reader
// cannot use would otherwise renumber every selector below it.
export const pageGuideTestIds = {
  panel: (guide: string) => `page-guide-${guide}-panel` as const,
  ring: (guide: string) => `page-guide-${guide}-ring-overlay` as const,
  pillButton: (guide: string) => `page-guide-${guide}-pill-button` as const,
  finishedToast: (guide: string) => `page-guide-${guide}-finished-status` as const,
  openButton: (guide: string) => `page-guide-${guide}-open-button` as const,

  // The opener, shown once per page per account.
  startButton: (guide: string) => `page-guide-${guide}-start-button` as const,
  notNowButton: (guide: string) => `page-guide-${guide}-not-now-button` as const,

  // A step.
  minimizeButton: (guide: string) => `page-guide-${guide}-minimize-button` as const,
  skipGuideButton: (guide: string) => `page-guide-${guide}-skip-guide-button` as const,
  stepBar: (guide: string, step: string) => `page-guide-${guide}-step-${step}-bar-button` as const,
  backButton: (guide: string, step: string) => `page-guide-${guide}-step-${step}-back-button` as const,
  nextButton: (guide: string, step: string) => `page-guide-${guide}-step-${step}-next-button` as const,
  askAgentButton: (guide: string, step: string) =>
    `page-guide-${guide}-step-${step}-ask-agent-button` as const,
  skipStepButton: (guide: string, step: string) =>
    `page-guide-${guide}-step-${step}-skip-step-button` as const,
  doneButton: (guide: string, step: string) =>
    `page-guide-${guide}-step-${step}-done-button` as const,
  waitNote: (guide: string, step: string) => `page-guide-${guide}-step-${step}-wait-text` as const,
  doneNote: (guide: string, step: string) => `page-guide-${guide}-step-${step}-done-text` as const,
} as const;
